import { createSlice } from '@reduxjs/toolkit';
import { WarehouseModel } from '../../components/model/WarehouseModel';

const WarehouseSlice = createSlice({
    name: 'warehouse',
    initialState: WarehouseModel,
    reducers: {
        setWarehouseObj(state, { payload }) {
            state.id = payload.id;
            state.productId = payload.productId;
            state.productName = payload.productName;
            state.invoice = payload.invoice;
            state.amount = payload.amount;
        },
    },
});

export default WarehouseSlice.reducer;
export const { setWarehouseObj } = WarehouseSlice.actions;
